var map = {
	"./en/analytics.json": 1702,
	"./en/auth.json": 3664,
	"./en/common.json": 6251,
	"./en/dashboard.json": 3198,
	"./en/imageUploader.json": 3401,
	"./en/landing.json": 7217,
	"./en/notifications.json": 9034,
	"./en/onboarding.json": 8095,
	"./en/products.json": 8634,
	"./en/workspaces.json": 5136,
	"./fr/analytics.json": 1569,
	"./fr/auth.json": 5637,
	"./fr/common.json": 2258,
	"./fr/dashboard.json": 773,
	"./fr/imageUploader.json": 9266,
	"./fr/landing.json": 3442,
	"./fr/notifications.json": 8821,
	"./fr/onboarding.json": 3178,
	"./fr/products.json": 3271,
	"./fr/workspaces.json": 1425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4365;